/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import { Heading, Stack, FontAwesomeIcon } from "components";
import { useAppAssetsWithSrc } from "Theme/EVENTS_ASSETS";
import { ScreenPage } from "templates";
import PageNote from "templates/PageNote";
import { useUI } from "state/UIContext";
import { useTranslation } from "react-i18next";

const DonePage = () => {
  const { t } = useTranslation();
  const { colorScheme } = useUI();
  const EVENT_ASSETS = useAppAssetsWithSrc();
  
  return (
    <ScreenPage
      desktopBG={
        colorScheme === "light"
          ? EVENT_ASSETS.alldone_BG_desktop.src
          : EVENT_ASSETS.alldone_BG_desktopDark.src
      }
      desktopBGFallback={
        colorScheme === "light"
          ? EVENT_ASSETS.alldone_BG_desktop.fallbackSrc
          : EVENT_ASSETS.alldone_BG_desktopDark.fallbackSrc
      }
      mobileBG={
        colorScheme === "light"
          ? EVENT_ASSETS.alldone_BG_mobile.src
          : EVENT_ASSETS.alldone_BG_mobileDark.src
      }
      mobileBGFallback={
        colorScheme === "light"
          ? EVENT_ASSETS.alldone_BG_mobile.fallbackSrc
          : EVENT_ASSETS.alldone_BG_mobileDark.fallbackSrc
      }
      showLogo={false}
    >
      <Stack component="article" className="h-full w-full">
        <div className="flex items-center gap-x-3">
          <Heading
            as="h2"
            className="text-2xl md:text-4xl -text--theme-colors-text-title"
          >
            {t('done')?.title}
          </Heading>{" "}
          <div className="-text--theme-colors-text-title">
            <FontAwesomeIcon name="fa-circle-check" size="xl" />
          </div>
        </div>
        <PageNote
          note={t('done')?.description}
          hasPolicy={false}
          spacing={5}
          className="-text--theme-colors-text-body text-sm md:text-base mt-2.5 md:mt-4"
        />
      </Stack>
    </ScreenPage>
  );
};
export default DonePage;
